import { useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID, isGoogleSignInConfigured } from '@/src/constants/googleAuth';

function logGoogleClientIdInDev(): void {
    if (process.env.NODE_ENV !== 'development') return;

    if (!isGoogleSignInConfigured) {
        console.warn(
            '[Envella] Google sign-in disabled: set NEXT_PUBLIC_GOOGLE_CLIENT_ID in .env.development to a Web OAuth client ID, then restart `yarn dev`.',
        );
        return;
    }
}

export function GoogleAuthProvider({ children }: { children: React.ReactNode }) {
    useEffect(() => {
        logGoogleClientIdInDev();
    }, []);

    if (!isGoogleSignInConfigured) {
        return <>{children}</>;
    }

    return <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{children}</GoogleOAuthProvider>;
}
